<script>
  // import Typewriter from "svelte-typewriter";
  import { fade } from "svelte/transition";
</script>

<svelte:head>
  <title
    >Helping people and companies maximize opportunities | Kyle Scott W.</title
  >
</svelte:head>

<div
  class="container pt-16 md:pt-24 px-6 mx-auto flex flex-wrap flex-col md:flex-row items-center"
>
  <div class="w-full lg:w-3/5 md:pr-16 pt-12 order-last lg:order-none">
    <h1 class="text-xl md:text-center w-6/8 lg:text-left lg:w-full lg:text-2xl">
      I'm a <!-- <span class="inline-block">
        <Typewriter loop interval={100}>
          <span>Designer</span>
          <span>Developer</span>
          <span>Entrepreneur</span>
        </Typewriter>
      </span> -->
      developer that is passionate about working on software to help people and companies
      maximize opportunities and solve problems.
    </h1>
  </div>

  <div
    class="w-full lg:w-2/5  mt-0 md:mt-16  justify-center flex "
    in:fade={{ duration: 3000 }}
  >
    <img
      class="h-44 md:h-80 image-bounce"
      src={"assets/images/enterprise-software-developer.svg"}
      alt="Kylescottw Icon"
    />
  </div>
</div>

<div class="container mx-auto items-center mt-14  hidden lg:flex">
  <div class="w-full mb-4 mt-8 ">
    <div class="grid  grid-cols-1 gap-8 lg:grid-cols-5 lg:gap-4 items-center">
      <a target="_blank" href="https://cloud.google.com/">
        <img
          src="assets/images/services/google-cloud.svg"
          alt="Use Google's infrastructure to build, operate, and grow your business technology with a multi-cloud environment"
          class="w-40 m-auto opacity-25 hover:opacity-100 opacity-rm-hover cursor-pointer"
          in:fade={{ duration: 4050 }}
        />
      </a>
      <a target="_blank" href="https://tailwindcss.com">
        <img
          src="assets/images/services/tailwindcss.svg"
          alt="Tailwind CSS is a highly customizable, low-level CSS framework that gives you all of the building blocks you need to build website designs without opinionated styles"
          class="w-40 m-auto opacity-25 hover:opacity-100 opacity-rm-hover cursor-pointer"
          in:fade={{ duration: 4050 }}
        />
      </a>
      <a href="https://www.mongodb.com/" target="_blank">
        <img
          src="assets/images/services/mongo-db.svg"
          alt="A Non-SQL database for modern web applications"
          class="w-40 m-auto opacity-25 hover:opacity-100 opacity-rm-hover cursor-pointer"
          in:fade={{ duration: 4050 }}
        /></a
      >
      <a href="https://reactjs.org/" target="_blank">
        <img
          src="assets/images/services/react.svg"
          alt="A JavaScript library for building user interfaces"
          class="w-40 m-auto opacity-25 hover:opacity-100 opacity-rm-hover cursor-pointer"
          in:fade={{ duration: 4050 }}
        />
      </a>
      <a href="https://nodejs.org" target="_blank">
        <img
          src="assets/images/services/nodejs.svg"
          alt="a JavaScript runtime built on Chrome's V8 JavaScript engine"
          class="w-40 m-auto opacity-25 hover:opacity-100 opacity-rm-hover cursor-pointer"
          in:fade={{ duration: 4050 }}
        />
      </a>
    </div>
  </div>
</div>

<div class="container mx-auto items-center mt-14">
  <div class="w-full">
    <div class="grid  grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-4">
      <a href="articles/decision-making-heuristics" class="hover:no-underline">
        <div class="shadow rounded cursor-pointer py-4 px-4   justify-center ">
          <h2 class="  text-gray-700 md:text-lg">Decision Making Heuristics</h2>
          <p class="mt-4 text-gray-600 h-28">
            Decision-making heuristics can reduce complexity, increase
            productivity, and improve problem solving.
          </p>
          <p class="text-xs font-thin text-gray-600 mt-4">3 min read</p>
        </div>
      </a>
      <a
        href="articles/the-economics-of-open-source-software"
        class="hover:no-underline"
      >
        <div class="shadow rounded cursor-pointer py-4 px-4   justify-center ">
          <h2 class="  text-gray-700 md:text-lg">
            The Economics of Open-source
          </h2>
          <p class="mt-4 text-gray-600 h-28">
            Open-source software is publicly available code that individuals and
            businesses can download, modify, and distribute according to a
            license.
          </p>
          <p class="text-xs font-thin text-gray-600 mt-4">5 min read</p>
        </div>
      </a>

      <a
        href="articles/applications-of-machine-learning"
        class="hover:no-underline"
      >
        <div class="shadow rounded cursor-pointer py-4 px-4   justify-center ">
          <h2 class="  text-gray-700 md:text-lg">
            Applications of machine learning
          </h2>
          <p class="mt-4 text-gray-600 h-28">
            In today's data-driven world, Machine Learning is being applied in
            multiple fields to process data more efficiently than ever before.
          </p>
          <p class="text-xs font-thin text-gray-600 mt-4">3 min read</p>
        </div>
      </a>

      <!-- <a href="articles/monoliths-to-microservices" class="hover:no-underline">
        <div class="shadow rounded cursor-pointer py-4 px-4   justify-center ">
          <h2 class="   text-gray-700 md:text-lg">
            From Monoliths To Microservices
          </h2>
          <p class="mt-4 text-gray-600 h-28">
            A Microservice architecture consists of separating an application
            into a series of small individual applications with specific job's.
          </p>
          <p class="text-xs font-thin text-gray-600 mt-4">2 min read</p>
        </div>
      </a> -->
    </div>
  </div>

  <div class="w-full">
    <p class="text-xs font-thin text-gray-600 text-right cursor-pointer mt-5 ">
      <a href="articles" class="hover:no-underline">
        Read More
        <svg
          class="text-gray-600 fill-current h-3 w-3 inline-block ml-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          ><path
            d="M20 10a10 10 0 1 1-20 0 10 10 0 0 1 20 0zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0zm-8 2H5V8h5V5l5 5-5 5v-3z"
          /></svg
        >
      </a>
    </p>
  </div>
</div>

<style>
  .image-bounce {
    -webkit-animation: mover 4s infinite alternate;
    animation: mover 4s infinite alternate;
  }
  @-webkit-keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }
  @keyframes mover {
    0% {
      transform: translateY(0);
    }
    100% {
      transform: translateY(-10px);
    }
  }
</style>
